import {initializeApp} from "firebase/app";
import {
  getMessaging,
  isSupported,
  onMessage,
  getToken,
} from "firebase/messaging";
import fcmService from "../services/fcmService";
import deviceInfoService from "../services/deviceInfoService";

export default {
  data() {
    return {
      firebaseApp: null,
      messaging: null,
      // local account
      // firebaseConfig: {
      //   apiKey: "AIzaSyC8gIu3gW37LT5romDok3LMU4QzzxEpacA",
      //   authDomain: "mbf-ecabinet.firebaseapp.com",
      //   projectId: "mbf-ecabinet",
      //   storageBucket: "mbf-ecabinet.appspot.com",
      //   messagingSenderId: "543152773455",
      //   appId: "1:543152773455:web:5dd5e32f949d7ab0990d3a",
      //   measurementId: "G-N2FV18CVZW"
      // },
      // keyPair: "BDoraVrH6In4KQsLuVcrund0_QrKjOVSSeuRDdFRImAegwQ7EsVSdBXmoBA5_CFQklJJgLvQcvFOH2Cg6iEsJoU"

      // true acccount
      firebaseConfig: {
        apiKey: "AIzaSyAGVbvVKIp2E4qXQvmIx5dtMJWRCdC2ghk",
        authDomain: "eoffice-ab613.firebaseapp.com",
        databaseURL: "https://eoffice-ab613.firebaseio.com",
        projectId: "eoffice-ab613",
        storageBucket: "eoffice-ab613.appspot.com",
        messagingSenderId: "1069472321711",
        appId: "1:1069472321711:web:4d0579401c8303d064c45a",
        measurementId: "G-DCVE2ZVRFJ"
      },
      keyPair: "BHOJdbGdmrddRNx6fZnUIQ7dF1UkdZ8gU8Y-CKi_pSUgThiLtI2Q9En4pGiF-GQB0YdT1Sy9SIIZa5qsKokLIHY"
    };
  },

  computed: {
    userId() {
      return this.$store.getters.userDeptRole.userId;
    },
    localStorageDeviceToken() {
      return fcmService.getFromLocalStorage()
    },
    deviceInfo() {
      return deviceInfoService.getDeviceData();
    }
  },

  async created() {
    this.initialize();
    await this.processDeviceToken(this.localStorageDeviceToken, this.deviceInfo, this.messaging);
    await this.onForegroundMessage(this.messaging);
  },

  methods: {
    // function deleteToken by firebase not working
    // deleteToken(this.messaging).then(() => {
    //   console.log('DISCONNECT')
    // }).catch((err) => {
    //   console.log(err)
    // });

    unSubscribeFcm() {
      return fcmService.clearSessionToken(this.localStorageDeviceToken, this.userId)
    },

    initialize() {
      this.firebaseApp = initializeApp(this.firebaseConfig);

      // if ("serviceWorker" in navigator) {
      //   console.log("#########YES##########");
      // }

      if (isSupported) {
        console.log("################ FCM isSupported ###############");
        this.messaging = getMessaging(this.firebaseApp);
      } else {
        return this.notify("Thông báo", "Trình duyệt không hỗ trợ Push Notify", "warning", 5000);
      }

      this.requestPermission();
    },

    async processDeviceToken(localstorageToken, deviceInfo, messagingCompat) {
      if (!localstorageToken) {
        // get token tu firebase ve va save vao localStorage
        const deviceToken = await this.generateFcmToken(messagingCompat);

        if (deviceToken) {
          await fcmService.saveToLocalStorage(deviceToken);
          const payload = {
            fcmToken: deviceToken,
            os: deviceInfo.deviceOs,
            version: deviceInfo.deviceOsVersion ? deviceInfo.deviceOsVersion : 'Unknown',
            modelCode: deviceInfo.deviceName,
          }
          await fcmService.saveDeviceToken(payload)
        }
      }
    },

    requestPermission() {
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        // alert("This browser does not support desktop notification");
        return this.notify("Notice", "This browser does not support desktop notification", "warning", 5000);
      }

      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === "granted") {
        // If it's okay let's create a notification
        console.log("Notification permission granted.");
      }

      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            // console.log("Notification permission granted.");
            this.notify("Notice", "Notification permission granted.", "success", 3000);
          }
        });
      }

    },

    async onForegroundMessage(messagingCompat) {
      if (messagingCompat) {
        onMessage(messagingCompat, payload => {
          console.log("Received foreground message ", payload);
          // const detailMsg = JSON.parse(payload.data.data)
          // console.log("-> detailMsg", detailMsg);
          const notificationTitle = payload.data.title;
          const notificationOptions = {
            body: payload.data.body,
            data: payload.data.url ? payload.data.url : '_blank',
            // tag: payload.data.tag,
            requireInteraction: true
            // icon: '',
            // badge: ''
          };
          if (!("Notification" in window)) {
            console.log("This browser does not support system notifications.");
          } else if (Notification.permission === "granted") {
            // Prevent multiple active tabs spamming Notification
            if (!document.hidden) {
              // If it's okay let's create a notification
              const notification = new Notification(
                notificationTitle,
                notificationOptions
              );
              notification.onclick = function (event) {
                event.preventDefault();
                // window.open(payload.data.url, "_blank");
                notification.close();
              };
            }
          }
        })
      }
    },

    async generateFcmToken(messagingCompat) {
      try {
        if (messagingCompat) {
          const swRegistration = await navigator.serviceWorker.register(
            `/static/firebase-messaging-sw.js`,
            {
              // type: 'module',
              scope: "/static/"
            }
          );

          const token = await getToken(messagingCompat, {
            serviceWorkerRegistration: swRegistration,
            vapidKey: this.keyPair
          });
          if (token) {
            return token;
          }
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
        // shows on the UI that permission is required
      } catch (err) {
        console.log(
          "Trình duyệt của bạn đang chặn thông báo của ứng dụng",
          err
        );
      }
      return null;
    },
  }
};



// WEBPACK FOOTER //
// ./src/firebase/fcmMixin.js